import { FormattedMessage, FormattedDate } from 'react-intl'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Button from '@mui/material/Button'
import { map, get, keyBy } from 'lodash'
import DeploymentStatusChip from '../../../../shared/components/DeploymentStatusChip'
import ResourceList from '../../../../shared/components/layouts/ResourceList'
import ResourceListRow from '../../../../shared/components/layouts/ResourceListRow'
import ResourceListCell from '../../../../shared/components/layouts/ResourceListCell'
import FlexColumn from '../../../../shared/components/layouts/FlexColumn'
import Flex from '../../../../shared/components/layouts/Flex'

const DeploymentsSection = ({ titleId, deployments, nodes, onCreateClick }) => {
  const nodesById = keyBy(nodes, 'id')

  const renderDeployment = (deployment) => {
    const nodeConfigs = get(deployment, 'nodeConfigs', [])

    return (
      <ResourceListRow key={deployment.id}>
        <ResourceListCell width={40} center>
          <DeploymentStatusChip deployment={deployment} />
        </ResourceListCell>
        <ResourceListCell grow>
          <FlexColumn gap={0.5}>
            <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>
              {deployment.name}
            </Typography>
            <Flex gap={0.5} sx={{ flexWrap: 'wrap' }}>
              {map(nodeConfigs, (config) => {
                const node = get(nodesById, config.nodeId)
                const nodeName = get(node, 'name', 'Unknown')
                const isDeployed = Boolean(config.deployedAt)
                return (
                  <Chip
                    key={config.id}
                    label={nodeName}
                    size="small"
                    variant={isDeployed ? 'filled' : 'outlined'}
                    color={isDeployed ? 'success' : 'default'}
                  />
                )
              })}
            </Flex>
          </FlexColumn>
        </ResourceListCell>
        <ResourceListCell minWidth={100}>
          <Typography variant="body2" color="text.secondary">
            <FormattedDate
              value={deployment.createdAt}
              year="numeric"
              month="short"
              day="numeric"
            />
          </Typography>
        </ResourceListCell>
      </ResourceListRow>
    )
  }

  return (
    <>
      <Flex fullWidth justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">
          <FormattedMessage id={titleId} />
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={onCreateClick}
        >
          <FormattedMessage id="deployments.createButton" />
        </Button>
      </Flex>
      <ResourceList
        items={deployments}
        renderItem={renderDeployment}
        emptyMessageId="deployments.empty"
      />
    </>
  )
}

export default DeploymentsSection
